// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IGracePeriodPropertyDto
 */
export interface IGracePeriodPropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IGracePeriodPropertyDto
     */
    grace_period_days_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IGracePeriodPropertyDto
     */
    grace_period_type?: IGracePeriodPropertyDtoGracePeriodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IGracePeriodPropertyDto
     */
    grace_period_type_state?: IGracePeriodPropertyDtoGracePeriodTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IGracePeriodPropertyDtoGracePeriodTypeEnum {
    TWO_AND_HALF_MONTH = 'TWO_AND_HALF_MONTH',
    CUSTOM = 'CUSTOM',
    DOES_NOT_APPLY = 'DOES_NOT_APPLY'
}
/**
* @export
* @enum {string}
*/
export enum IGracePeriodPropertyDtoGracePeriodTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IGracePeriodPropertyDto interface.
 */
export function instanceOfIGracePeriodPropertyDto(value: object): value is IGracePeriodPropertyDto {
    return true;
}

export function IGracePeriodPropertyDtoFromJSON(json: any): IGracePeriodPropertyDto {
    return IGracePeriodPropertyDtoFromJSONTyped(json, false);
}

export function IGracePeriodPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IGracePeriodPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'grace_period_days_amount': json['grace_period_days_amount'] == null ? undefined : json['grace_period_days_amount'],
        'grace_period_type': json['grace_period_type'] == null ? undefined : json['grace_period_type'],
        'grace_period_type_state': json['grace_period_type_state'] == null ? undefined : json['grace_period_type_state'],
    };
}

export function IGracePeriodPropertyDtoToJSON(json: any): IGracePeriodPropertyDto {
    return IGracePeriodPropertyDtoToJSONTyped(json, false);
}

export function IGracePeriodPropertyDtoToJSONTyped(value?: IGracePeriodPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'grace_period_days_amount': value['grace_period_days_amount'],
        'grace_period_type': value['grace_period_type'],
        'grace_period_type_state': value['grace_period_type_state'],
    };
}

